import { BookOpenIcon, CalendarCheckIcon, FileSpreadsheetIcon, HouseIcon, LayoutDashboardIcon, LucideIcon } from 'lucide-react';
import { ScreenId } from '../types/navigation';

export interface NavItem {
  id: ScreenId;
  label: string;
  audience: string;
  icon: LucideIcon;
  iconBg: string;
}

export const navItems: NavItem[] = [
  { id: 'how', label: 'How Commissions Work', audience: 'Everyone', icon: BookOpenIcon, iconBg: '#032D60' },
  { id: 'plans', label: 'LO Standard Plan', audience: 'Rule Editors', icon: FileSpreadsheetIcon, iconBg: '#F49756' },
  { id: 'loan', label: 'LN-2026-004812', audience: 'Loan record', icon: HouseIcon, iconBg: '#3BA755' },
  { id: 'statement', label: 'Commission Dashboard', audience: 'LO / Manager', icon: LayoutDashboardIcon, iconBg: '#7F8DE1' },
  { id: 'close', label: 'Period Close', audience: '', icon: CalendarCheckIcon, iconBg: '#06A59A' },
];
